<template>
  <div class="interaction-container--flex">
    <div class="filter" v-for="(filter) in this.fabricFilters" :key="`ff-${filter.heading}`" ref="filter" >
      <div class="filter_values" ref="content">      
        <template v-if="filter.type ==='COLOR'">
          <div class="interaction-container--color" :class="{active: isOpen}">
            <div class="dropdown__wrapper">
              <label class="label" @click="handleDropDownClick()">{{ filter.heading }}</label>
              <div class="dropdown__container" ref="dropdownContainer">
                <div class="dropdown">
                  <div class="selected_wrapper" @click="handleDropDownClick()">
                    <span class="dropdown_label" v-if="filter.activeFilters">
                      <span>{{ filter.activeFilters }}</span>
                    </span>
                    <span class="dropdown_label" v-else-if="!isOpen">
                      <span>All</span>
                    </span>
                    <span class="dropdown_label" v-else>
                      <span>{{ filter.emptyOption }}</span>
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none" class="chevron" :class="{ active: isOpen }">
                      <path d="M1.33789 0.647461L0.837891 1.02164L7.16904 7.35279L13.5002 1.02164L12.9629 0.647461L7.16904 6.39746L1.33789 0.647461Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <dropdown-wrapper :open="isOpen">
                    <div class="option_container" ref="option_container">
                      <div
                        v-for="value in filter.values" 
                        :key="`fv--${value}`"
                        class="option"
                        :class="{active: value.active}" 
                        @click="handleFilterSelected(filter,value)"
                        :data-option-val="option"
                      >
                        {{ value.value }}
                      </div>
                      <div
                        @click="handleFilterReset(filter,'')"
                        class="option"
                        :class="{active: !filter.activeFilters}" 
                      >
                        All
                      </div>
                    </div>
                  </dropdown-wrapper>
                </div>
              </div>
            </div>
            <div class="interaction-container">
              <label class="label">Color Name</label>
              <span class="active_value">{{
                activeOption == decideLaterOption
                  ? decideLaterText
                  : activeOption.title
              }}</span>
            </div>
          </div>
        </template>
        <template v-else-if="filter.type ==='RADIO'">
          <div class="label">
            <span>{{ filter.heading }}</span>
          </div>
          <div class="radio-options">
            <label v-for="value in  filter.values" 
              :key="`fv--${value}`"
              class="radio-option"
              :class="{ active: value.active }"
              :data-option-val="option">
              <input type="radio" name="radio-input--fabric" 
                :checked="displayedOption === option"       
                @change="handleFilterSelected(filter,value)" />
              <span class="custom-radio"><span></span></span>
              <span>{{ value.value }}</span>
            </label>
            <label
              class="radio-option"
              :data-option-val="clear">
              <input type="radio" name="radio-input--fabric" 
                :checked="!filter.activeFilters"       
                @change="handleFilterReset(filter,'')" />
              <span class="custom-radio"><span></span></span>
              <span>All</span>
            </label>
          </div>
        </template>
      </div>
    </div>
    <div class="image_options" ref="fabricOptions">
      <!-- TODO this is just for testing -->
      <div
        v-for="option in this.options"
        :key="option.title"
        class="image_option"
        :data-option="option.sku_code"
        :class="{is_active: option === displayedOption && activeOption != decideLaterOption, is_hovered: hoveredOption == option.sku_code }"
        @click="handleOptionClick(option)"
        @mouseenter="handleMouseEnter(option)"
        @mouseleave="handleMouseLeave(option)"
      >
        <div class="hover_container">
          <div
            class="option_details"
            :class="{ detail_background: option.background_needed }"
          >
            <div class="option_title">{{ option.title }}</div>
            <div class="option_collection">
              {{ option.fabric_options[0] }}
            </div>
          </div>
          <div class="image_image">
            <AppImage :lazy-src="option.image_url" :alt="option.title"/>
          </div>
        </div>
        <div v-if="option === displayedOption && activeOption != decideLaterOption" class="active_ring">
          &nbsp;
        </div>
        <div class="image_image">
          <AppImage :lazy-src="option.image_url" :alt="option.title"/>
        </div>
      </div>
    </div>
    <div
      v-if="decideLaterOption"
      :class="{
        details_wrapper: decideLaterOption.description,
      }"
    >
      <div>
        <div class="decide-later__upper">
          <div
            class="option__decide-later"
            :data-option-val="decideLaterOption.value"
            v-html="decideLaterOption.label"
            
          />
          <div class="decide-later__actions">
            <div
              class="decide-later__action"
              :class="{'decide-later__action--active': activeOption == decideLaterOption}"
              @click="() => handleDFLOption(true)"
            >
              Yes
            </div>
            <div 
              class="decide-later__action" 
              :class="{'decide-later__action--active': activeOption != decideLaterOption}" 
              @click="() => handleDFLOption(false)"
            >
              No
            </div>
          </div>

        </div>

        <div class="dropdown__wrapper" v-if="decideLaterOption.description">
          <div>
            <div class="selected_wrapper" @click="handleExpandClick()">
              <span class="dropdown_label" v-if="isExpanded">
                <span>Hide details</span>
              </span>
              <span class="dropdown_label" v-else>
                <span>See more details</span>
              </span>
            </div>
            <dropdown-wrapper :open="isExpanded">
              <div class="description" v-html="decideLaterOption.description" />
            </dropdown-wrapper>
          </div>
        </div>
      </div>
      <!-- <span class="custom-radio" :class="{ is_active: activeOption == decideLaterOption }" @click="handleDFLOption"><span></span></span> -->
    </div>
  </div>
</template>

<script>
import AppImage from "./AppImage.vue";
import axios from "axios";
import DropdownWrapper from "./DropdownWrapper.vue";
import { mapGetters } from "vuex";

export default {
  components: { AppImage, DropdownWrapper },
  name: "FabricSelector",
  props: {
    // isOpen: {
    //   type: Boolean,
    //   default: false,
    // },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    displayImage: {
      type: Boolean,
      default: false,
    },
    decideLaterValue: {
      type: String,
    },
    fabricDecideLaterText: {
      type: String,
    },
    fabricHeading: {
      type: String,
      default: "This is the heading",
    },
    fabricActionText: {
      type: String,
      default: "This is the action",
    },
    optionFunction: {
      type: String,
    },
    defaultValueFunction: {
      type: String,
    },
    setFunction: {
      type: String,
    },
    setStateFunction: {
      type: String,
    },
    emptyOptionFunction: {
      type: String,
    },
    activeOptionFunction: {
      type: String,
    },
    chooseNowOptionFunction: {
      type: String,
    },
    decideLaterOptionFunction: {
      type: String,
    },
    chooseTextFunction: {
      type: String,
    },
    decideLaterTextFunction: {
      type: String,
    },
  },
  data() {
    return {
      filtersOpen: false,
      displayedOption: this.activeOption,
      availableOptions: [],
      isInitial: true,
      hoveredOption: null,
      isOpen: false,
      // TODO move this to a config setting
      IMAGE_URL_TEMPLATE: "/cdn/shop/files/{productTitle}_{fabricName}_FRONT.jpg"
    };
  },
  watch: {
    options(newOptions) {
      if (newOptions.length) {
        if (!newOptions.includes(this.displayedOption)) {
          this.displayedOption = newOptions[0]
          this.$store.dispatch(this.setFunction, this.displayedOption);
          this.$store.dispatch(this.setStateFunction, false);
          this.maybeSetRenderingImage()
          this.$emit("option-changed");
        }
      }
    },
    activeOption() {
      if (this.isInitial) {
        this.isInitial = false
      }
    }
  },
  computed: {
    options() {
      let fabricOptionsCopy = [...this.$store.getters[this.optionFunction]]
      if (this.activeFilters.length) {
        const filteringObject = {}
        this.activeFilters.forEach((filter) => {
          filteringObject[filter.appValue] = filter.values.map((value) => value.value)
        })
        fabricOptionsCopy = fabricOptionsCopy.filter((fabricOption) => {
          let matches = 0
          const filters = Object.keys(filteringObject)
          filters.forEach((key) => {
            const splitKey = key.split('.')
            let fabricValue = fabricOption
            for (let x = 0; x < splitKey.length; x++) {
              fabricValue = fabricValue[splitKey[x]]
              if (!fabricValue) {
                break
              }
            }
            if (fabricValue) {
              if (typeof fabricValue == 'object') {
                // This will handle the array and object ones
                if (fabricValue.length) {
                  // This is for the array
                  for (let x = 0; x < fabricValue.length; x++) {
                    if (filteringObject[key].includes(fabricValue[x])) {
                      matches ++
                      break
                    }
                  }
                  
                }
                // TODO objects
              } else {
                // String
                if (filteringObject[key].includes(fabricValue)) {
                  matches ++ 
                }
              }
            }
          })
          if (matches === filters.length) {
            return true
          }
          return false 
          
        })
      }
      return fabricOptionsCopy;
    },
    activeOption() {
      return this.$store.getters[this.activeOptionFunction];
    },
    defaultValue() {
      return this.$store.getters[this.defaultValueFunction];
    },
    emptyOption() {
      return this.$store.getters[this.emptyOptionFunction];
    },
    chooseNowOption() {
      return this.$store.getters[this.chooseNowOptionFunction];
    },
    decideLaterOption() {
      return this.$store.getters[this.decideLaterOptionFunction];
    },
    chooseText() {
      return this.$store.getters[this.chooseTextFunction];
    },
    decideLaterText() {
      return this.$store.getters[this.decideLaterTextFunction];
    },
    ...mapGetters({
      productTitle: "products/getProductTitle",
      activeImage: "images/getActiveImage",
      activeProduct: "products/getActiveProduct",
      fabricFilters: "fabrics/getFilters",
      colorConfig: "fabrics/getColorConfig",
      activeFilters: "fabrics/getActiveFilters"
    }),
    activeImageUrl() {
      return  window.location ? 
        this.activeImage && !this.activeImage.includes(window.location.origin) ?
          `${window.location.origin}/cdn/shop/${this.activeImage}` :
          this.activeImage
        : this.activeImage
    },
    isInverted() {
      if (this.activeProduct.orientation && this.activeProduct.orientation.match(/right/i)?.length) {
        return true
      }
      return false
    }
  },
  mounted() {
    if (this.activeOption != this.decideLaterOption) {
      this.displayedOption = this.activeOption;
    } else {
      this.displayedOption = this.options[0];
    }
    setTimeout(() => {
      // TODO maybe surpress initial lazyload?
      if (this.displayedOption != this.decideLaterOption) {
        this.maybeSetRenderingImage()
      }
    }, 100)
    
  },
  methods: {    
    handleMouseEnter(option) {
      this.hoveredOption = option.sku_code
      
    },
    handleMouseLeave() {
      this.hoveredOption = null
    },
    handleDropDownClick() {
      if (this.isOpen) {
        this.isOpen = false
        document.removeEventListener('click', this.handleWindowClicked)
        // this.$emit("close-dropdown");
      } else {
        this.isOpen = true
        // this.$emit("open-dropdown");
        document.addEventListener('click', this.handleWindowClicked)
      }
    },

    handleWindowClicked(e) {
      if (!this.$refs.dropdownContainer[0].contains(e.composedPath()[0])) {
        this.handleDropDownClick()
      }
    },
    handleExpandClick() {
      this.isExpanded = !this.isExpanded;
    },
    handleDecideLater() {
      this.$store.dispatch(this.setFunction, this.decideLaterOption);
      this.$store.dispatch(this.setStateFunction, true);
      this.displayedOption = this.options[0];
      this.$emit("option-changed");
      // this.$emit("close-dropdown");
    },
    handleFabricSelect() {  
      this.$store.dispatch(this.setFunction, this.displayedOption);
      this.$store.dispatch(this.setStateFunction, false);
      this.$emit("option-changed");
      this.maybeSetRenderingImage()
      this.$emit("close-dropdown");
    },
    handleYAMLClick(yamlOption) {
      const yamlSKU = yamlOption.sku_code;
      const newOption = this.options.find(
        (option) => option.sku_code === yamlSKU
      );
      if (newOption) {
        this.displayedOption = newOption;
        this.$store.dispatch(this.setFunction, this.displayedOption);
        this.$store.dispatch(this.setStateFunction, false);
        this.maybeSetRenderingImage()
        this.$emit("option-changed");
      }
    },
    handleOptionClick(option) {
      this.displayedOption = option;
      this.$store.dispatch(this.setFunction, this.displayedOption);
      this.$store.dispatch(this.setStateFunction, false);
      this.maybeSetRenderingImage()
      this.$emit("option-changed");
    },
    handleDFLOption(newDFL) {
      if (newDFL) { 
        this.handleDecideLater();
      } else {
        this.handleFabricSelect()
      }
      // console.log("THIS FIRED?")
      
      this.$emit("close-dropdown");
    },
    maybeSetRenderingImage() {
      let workingTitle = this.displayedOption.title || ''
      workingTitle = workingTitle.toLowerCase().split(" ").map((part) => {
        return (part.split('').map((elm, index) => index === 0 ? elm.toUpperCase() : elm)).join('')
      }).join("_")

      let workingProduct = this.productTitle.replaceAll(" ",'_').replaceAll("'",'_').toUpperCase()

      let workingUrl = `${window.location.origin}${this.IMAGE_URL_TEMPLATE}`.replace('{productTitle}', workingProduct).replace('{fabricName}',workingTitle)
      axios.get(workingUrl).then(() => {
        this.$store.dispatch("images/activateImage", workingUrl);
        document.dispatchEvent(new CustomEvent('update-rendering', {
          detail: {
            url: workingUrl
          }
        }))
      }).catch(() => {
        // Fail Request try with uppercase
        workingUrl = `${window.location.origin}${this.IMAGE_URL_TEMPLATE}`.replace('{productTitle}', workingProduct.toUpperCase()).replace('{fabricName}',workingTitle.toUpperCase())
        axios.get(workingUrl).then(() => {
          this.$store.dispatch("images/activateImage", workingUrl);
          document.dispatchEvent(new CustomEvent('update-rendering', {
            detail: {
              url: workingUrl
            }
          }))
        }).catch(()=> {
          // Fail Request, don't update
        })
      })
    },
    handleFilterClick(filterIndex) {
      // It'll either be null or a single
      let currentFilter = this.$refs.filter
      let currentContent = this.$refs.content
      if (this.$refs.filter && this.$refs.filter.length) {
        // THIS IS AN ARRAY, handle it accordingly
        currentFilter = this.$refs.filter[filterIndex]
        currentContent = this.$refs.content[filterIndex]
      }
      if (currentFilter) {
        if (currentFilter.classList.contains('active')) {
          currentFilter.classList.remove('active')
          currentContent.style.maxHeight = null;
        } else {
          currentFilter.classList.add('active')
          currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
        }
      }
    },
    handleFilterSelected(filter,value) {
      this.$store.dispatch("fabrics/activateFabricFilter", {filterToActivate:filter, filterValue:value, joinActiveFilters: false});
    },
    handleFilterReset(filter) {
      this.$store.dispatch("fabrics/resetFabricFilter", {filterToReset:filter});
    }
  },
};
</script>

<style scoped>
.dropdown {
  padding: 5px 15px;
  border-radius: 25px;
  border: var(--border-thickness) solid;
  cursor: pointer;
  max-width: 220px;
  margin-left: auto;
  width: calc(100% - 30px);
}
.dropdown_label {
  flex-grow: 1;
  text-align: left;
  user-select: none;
  position: relative;
  text-transform: capitalize;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; 
}
.selected_wrapper {
  display: flex;
  align-items: center;
}
.option_container {
  text-align: left;
  padding-top: 10px;
}
.option {
  margin-bottom: 2px;
  user-select: none;
  font-size: 12px;
  font-weight: 500;
  line-height: 125%;
}
.option:not(.active):hover,
.option.active {
  text-decoration-line: underline;
}
.additional_detail {
  margin: 10px 0;
}
.image_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image_wrapper img {
  width: 100%;
  min-height: 150px;
  object-fit: cover;
}
.chevron {
  height: 1rem;
  transition: 0.4s ease-in-out;
}
.chevron.active {
  transform: rotate(180deg);
}
.details_wrapper {
  margin-top: 10px;
  text-align: left;
  padding: 7px 10px 10px;
  user-select: none;
  background-color: var(--option-details-background);
  color: var(--text-color, #2C2B2A);
  font-family: Visby;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%; 
}
.details_wrapper {
  margin: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 20px;
  border: 1px solid var(--border-color);
  background-color: var(--additional-details-background);
}
.details_wrapper .dropdown_label {
  font-size: 10px;
  text-decoration-line: underline;
  cursor: pointer;
}
.details_wrapper .description {
  font-size: 10px;
  margin-top: 5px;
}
.details_wrapper >>> a {
  color: var(--text-color);
  padding: 5px;
  text-decoration: none;
  border: 1px solid;
  display: flex;
  width: fit-content;
  margin: 5px 0 0;
  letter-spacing: unset;
  transition: 0.3s ease-in-out;
}
.details_wrapper >>> a:visited {
  color: var(--text-color);
}
/* .option__decide-later {
 cursor: pointer;
 
} */

/* image picker */
.image_options {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  row-gap: 5px;
  -moz-column-gap: 5px;
  column-gap: 5px;
  margin: 5px 0 0;
}
.image_option {
  position: relative;
  border: 1px solid;
  border-color: var(--modal-border-color);
  padding-bottom: 40px;
  transition: .2s ease-in;
  cursor: pointer;
}
.image_image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  overflow: hidden;
  background: var(--modal-image-background-color);
}
.image_image img {
  width: 100%;
  min-height: 150px;
  -o-object-fit: cover;
  object-fit: cover;
}
.active_ring {
  border: 1px solid;
  border-color: var(--border-color);
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
}
.active_ring::before {
  border: 1px solid var(--active-option-foreground, #fff);
  content: " ";
  top:0;
  left:0;
  position: absolute;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  z-index: 1;
}
.active_value {
  font-weight: 400;
}
@media screen and (min-width: 1180px) {
  .image_options {
    grid-template-columns: repeat(12, 1fr);
  }
}

.image_options {
  margin: 0 0 10px;
}

.filter {
  padding: 0 0 10px;
}
.filter_values {
  transition: 0.5s ease;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 5px;
}
.radio-options label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  min-width: unset;
}
.radio-options input {
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
.custom-radio {
  float: left;
  width: 15px;
  height: 15px;
  margin: 0 5px 0 0;
  vertical-align: middle;
  cursor: pointer;
  background-repeat: no-repeat;
  border: 1px solid rgba(0, 0, 0, .3);
  border-radius: 100%;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  position: relative;
}
.is_active.custom-radio:after,
input:checked+.custom-radio:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 11px;
  height: 11px;
  background-color: #000c;
  border-radius: 50%;
}
.radio-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.filter_values .radio-options {
  grid-template-columns: auto auto auto;
  gap: 6px;
}
.interaction-container--flex {
  display: grid;
  padding: 0;
  -moz-column-gap: 10px;
  column-gap: 10px;
  color: var(--general-foreground);
  line-height: 1;
  align-items: center;
  width: 100%;
  position: relative;
}
.interaction-container--color {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.interaction-container--color .dropdown__wrapper {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 7px
}
.interaction-container--color .active_value {
  font-weight: 400;
  line-height: 30px;
}
.interaction-container {
  grid-template-columns: unset;
}
.decide-later__upper {
  display: flex;
  flex-wrap: wrap;
  column-gap: 8px;
  row-gap: 5px;
  align-items: center;
  margin-bottom: 5px;
}
.decide-later__actions {
  display: flex;
  gap: 4px;
}
.decide-later__action {
  padding: 4px 8px;
  cursor: pointer;
  border: 1px solid var(--border-color);
  border-radius: 15px;
  cursor: pointer;
  transition: 0.2s ease;
}
.decide-later__action--active {
  background-color: var(--border-color);
  color: var(--active-option-foreground);
}

@media screen and (min-width: 768px) {
  .filters_wrapper {
    padding: 30px 20px 0;
  }
  .filters_wrapper {
    width: calc(100% - 40px);
  }
  .filter_values {
    /* flex-direction: column;
    gap: 0; */
    gap: 10px;
  }
  .details_wrapper {
    font-size: 14px;
    /* padding: 15px; */
  }
  .details_wrapper .description,
  .details_wrapper .dropdown_label {
    font-size: 12px;
  }
  .filter_values .radio-options {
    display: flex;
    gap: 20px;
  }
  .filter {
    padding: 0 0 15px;
  }
}
@media screen and (min-width: 1024px) {
  .interaction-container--color {
    display: grid;
    padding: 0;
    -moz-column-gap: 20px;
    column-gap: 20px;
    grid-template-columns: 1fr 1fr;
    align-items: start;
    width: 100%;
  }
  .interaction-container--color .interaction-container {
    line-height: 30px;
  }
  .image_options {
    grid-template-columns: repeat(12, 1fr);
  }
}
.hover_container {
  position: absolute;
  background: #000;
  height: 150px;
  z-index: 2;
  width: 175px;
  right: 25%;
  bottom: 25%;
  border: 2px solid #fff;
  opacity: 0;
  pointer-events: none;
  transition: 0.2s ease;
}
@media screen and (min-width: 768px) {
  .is_hovered .hover_container {
    pointer-events: unset;
    opacity: 1;
  }
}

.hover_container .image_image {
  border: 1px solid #000;
  box-sizing: border-box;
}
.option_details {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 1;
  padding: 5px;
  color: var(--modal-option-text);
  background-color: var(--option-details-foreground);
}
.option_title {
  font-size: 14px;
}
.option_collection {
  font-size: 12px;
  font-style: italic;
}
</style>
